import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Chanel from "../../../assets/images/HomePage/Chanel.webp";
import ChanelS from "../../../assets/images/HomePage/ChanelS.webp";
import ChristanDior from "../../../assets/images/HomePage/ChristanDior.webp";
import Gucci from "../../../assets/images/HomePage/Gucci.webp";
import GucciS from "../../../assets/images/HomePage/GucciS.webp";
import Louis from "../../../assets/images/HomePage/Louis.webp";
import LouisS from "../../../assets/images/HomePage/LouisS.webp";
import Jacquemus from "../../../assets/images/HomePage/Jacquemus.webp";
import JacquemusS from "../../../assets/images/HomePage/JacquemusS.webp";
import HermesS from "../../../assets/images/HomePage/birkin_bag_afpS.webp";
import Hermes from "../../../assets/images/HomePage/birkin_bag_afp.webp";
import amina from "../../../assets/images/HomePage/amina.webp";
import BottegaVeneta from "../../../assets/images/HomePage/BottegaVeneta.webp";
import BottegaVenetaS from "../../../assets/images/HomePage/BottegaVenetaS.webp";
import { useDispatch } from "react-redux";
import { SetSearch } from "../../../features/TopSearches/TopSearchesSlice";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import {
  SetSelectdPage,
  SetSizeFilter,
  SetTopSizeFilter,
  SortProducts,
  resetLoadingNumber,
} from "../../../features/Products/ProductSlice";
import LoadingComp from "../LoadingComp";

function DesignerBrand() {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { products } = useSelector((store) => store.allproducts);
  const details1 = [
    {
      id: "iBJgqgPm9in6WB4B5aG1",
      img: ChristanDior,
      srcset: `${ChristanDior}  250w, ${ChristanDior} 1080w`,
      brand: `  ${i18n.language == "en" ? "Dior" : "ديور"}`,
      alt: "Designer clothing: white Lady Dior bag",
    },

    {
      id: "NAHb0mOIuEtPZcqMAn94",
      img: Louis,
      srcset: `${LouisS}  250w, ${Louis} 1080w`,
      brand: `  ${i18n.language == "en" ? "Louis Vuitton" : "لويس فويتون"}`,
      class: "ps-3 ps-md-3",
      alt: "Designer clothing: Louis Vuitton Noe bag",
    },
    {
      id: "mQaMXzznjUirDmeCyPmb",
      img: Hermes,
      srcset: `${HermesS}  250w, ${Hermes} 1080w`,
      brand: `  ${i18n.language == "en" ? "Hermès" : "هيرميس"}`,
      class: "ps-3 ps-md-3",
      alt: "Designer clothing: Hermès Birkin",
    },
    {
      id: "vsUMeHPID1Rs7QdZiHD3",
      img: BottegaVeneta,
      srcset: `${BottegaVenetaS}  250w, ${BottegaVeneta} 1080w`,
      brand: `  ${i18n.language == "en" ? "Bottega Veneta" : "بوتيغا فينيتا"}`,
      class: "ps-3 ps-md-3",
      alt: "Designer clothing: blue Bottega Veneta pouch",
    },
    {
      id: "htjMB0lyqYD7dqviSd58",
      img: Chanel,
      srcset: `${ChanelS}  250w, ${Chanel} 1080w`,
      brand: `  ${i18n.language == "en" ? "Chanel" : "شانيل"}`,
      class: "ps-3 ps-md-3 ",
      alt: "Designer clothing: pink Chanel double classic flap bag",
    },
    {
      id: "gx48EN58tk80Kcwgl1xY",
      img: Gucci,
      srcset: `${GucciS}  250w, ${Gucci} 1080w`,
      brand: `  ${i18n.language == "en" ? "Gucci" : "غوتشي"}`,
      class: "ps-3 ps-md-3",
      alt: "Designer clothing: Gucci 1955 horsebit bag",
    },
  ];

  const AminaProduct = {
    id: "0o3KYKs3rd8WlhSl8dbq",
    img: amina,
    srcset: `${amina}  250w, ${amina} 1080w`,
    brand: `  ${i18n.language == "en" ? "Amina Muaddi" : "أمينة معادي"}`,

    class: "ps-3 ps-md-3",
  };

  const JacquemusProduct = {
    id: "1qzwoL33uzzcKF9rlSrP",
    img: Jacquemus,
    srcset: `${JacquemusS}  250w, ${Jacquemus} 1080w`,
    brand: `  ${i18n.language == "en" ? "Jacquemus" : "جاكيموس"}`,

    class: "ps-3 ps-md-3",
  };

  const productFind = products.map((brand) => brand.idBrand);

  const set = new Set(productFind);
  const productFindAmina = products.filter(
    (brand) => brand.idBrand == AminaProduct.id
  ).length;

  const productFindJacquemus = products.filter(
    (brand) => brand.idBrand == JacquemusProduct.id
  ).length;
  useEffect(() => {
    dispatch(SortProducts(""));
    sessionStorage.setItem("selectedItemIndex", "");
    dispatch(resetLoadingNumber(30));
    dispatch(SetSelectdPage(0));
    dispatch(SetSizeFilter([]));
    dispatch(SetTopSizeFilter([]));
  }, []);
  if (i18n.language == "ar") {
    var arabStyle = {
      letterSpacing: "0em",
    };
  } else {
    var arabStyle = {};
  }
  return (
    <>
      <h1
        style={arabStyle}
        className={`title-section pb-md-3 pb-3 px-md-5  pt-lg-1 pt-4 ${
          i18n.language == "en" ? `text-start` : `text-end`
        }`}
      >
        {t("SHOP BY BRAND")}
      </h1>
      {/* <h2   style={arabStyle}  className="sub-section px-lg-0 px-3 pt-md-2 pb-4 pb-lg-5 text-center" >
        {t("home-sub3")}
      </h2> */}
      {
        // !products||products.length==0?
        //   <LoadingComp heightcomp="designerheight"/>
        // :

        <div
          className={`row scroll pb-5 ${
            i18n.language == "en" ? "ms-0 me-4" : `me-0 ms-4`
          }`}
          id="style-2"
        >
          <div
            className="col-12 d-flex  px-md-5 px-0 justify-content-between   mx-0 "
            id="style-2"
          >
            {details1.map((detail) => (
              // set.has(detail.id) &&
              <div
                onClick={() =>
                  navigate(`/products?brand=${detail.id}`) &
                  window.scrollTo({ top: 0, left: 0, behavior: "instant" }) &
                  dispatch(SetSearch(""))
                }
                className="text-decoration "
                key={detail.id}
              >
                <div className={detail.class}>
                  <div>
                    <img
                      loading="lazy"
                      src={detail.img}
                      srcSet={detail.srcset}
                      alt="brand-img"
                      className="designrer-brand"
                    />
                  </div>
                  <div className="homepagesubtxt text-center pt-md-3 pt-2">
                    {detail.brand}
                  </div>
                </div>
              </div>
            ))}
            {set.has(AminaProduct.id) == true && productFindAmina >= 30 ? (
              <div
                onClick={() =>
                  navigate(`/products?brand=${AminaProduct.id}`) &
                  window.scrollTo({ top: 0, left: 0, behavior: "instant" }) &
                  dispatch(SetSearch(""))
                }
                className="text-decoration "
                key={AminaProduct.id}
              >
                <div className={AminaProduct.class}>
                  <div>
                    <img
                      loading="lazy"
                      src={AminaProduct.img}
                      alt="brand-img"
                      className="designrer-brand"
                    />
                  </div>
                  <div className="homepagesubtxt text-center pt-3">
                    {AminaProduct.brand}
                  </div>
                </div>
              </div>
            ) : null}

            {set.has(JacquemusProduct.id) && productFindJacquemus >= 30 ? (
              <div
                onClick={() =>
                  navigate(`/products?brand=${JacquemusProduct.id}`) &
                    window.scrollTo({ top: 0, left: 0, behavior: "instant" }) &&
                  dispatch(SetSearch(""))
                }
                className="text-decoration "
                key={JacquemusProduct.id}
              >
                <div className={JacquemusProduct.class}>
                  <div>
                    <img
                      loading="lazy"
                      src={JacquemusProduct.img}
                      alt="brand-img"
                      className="designrer-brand"
                    />
                  </div>
                  <div className="brand-image-txt text-center pt-md-3 pt-2">
                    {JacquemusProduct.brand}
                  </div>
                </div>
              </div>
            ) : null}
          </div>
        </div>
      }
    </>
  );
}

export default DesignerBrand;
